// extracted by mini-css-extract-plugin
export var list = "ReadNext-module--list--dCWKD";
export var root = "ReadNext-module--root--moEzz";